import { DocumentModel } from "@models/documents/documentmodel";

export class DocumentsModel {
    documents: DocumentModel[];
}
